/**
 * @author Matthew Rogers.
 */
var topic_errorsBind = { errors: '=' };
var TopicErrorsController = (function () {
    function TopicErrorsController(socket, $scope, env, admin, Dialog, settings, $filter) {
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.admin = admin;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$filter = $filter;
    }
    TopicErrorsController.prototype.showErrors = function (event) {
        var items = {
            dateFormat: this.settings.up.preferences.dateFormat,
            errs: this.errors
        };
        this.Dialog.updateValidForm(event, items, 'display-topic-errors.html');
    };
    TopicErrorsController.$inject = ['socket', '$scope', 'env', 'admin', 'Dialog', 'settings', '$filter'];
    return TopicErrorsController;
}());
var TopicErrorsComponent = (function () {
    function TopicErrorsComponent() {
        this.templateUrl = 'topic-errors.html';
        this.bindings = topic_errorsBind;
        this.controller = TopicErrorsController;
    }
    return TopicErrorsComponent;
}());
angular
    .module('application')
    .component('topicErrors', new TopicErrorsComponent());

//# sourceMappingURL=topic.errors-component.js.map
